import { combineReducers } from 'redux';
import chartsReducer from './charts';
import devicesReducer from './devices';
import eventsReducer from './events';
import uiReducer from './ui';
import userReducer from './user';
import sensorsReducer from './sensors';
import localeReducer from './locale';
import timezoneReducer from './timezone';
import appWidgetReducer from './appwidgets';
import { LOGOUT } from '../constants/index';
import profilesReducer from './profiles';
import sidebarReducer from './sidebar';
import userProfileWidgetsReducer from './userProfileWidgets';
import userProfileUnitsReducer from './userProfileUnits';
import userManagerReducer from './userManager';
import unitManagerReducer from './unitManager';
import organisationManagerReducer from './organisationManager';
import modelVariantReducer from './modelVariant';
import setpointsReducer from './setpoints';

import modelComponentPositionsReducer from './modelComponentPositions';
import alarmsReducer from './alarms';
import eventActionReducer from './eventAction';
import eventActionStatusReducer from './eventActionStatus';
import signalTranslationEquationReducer from './signalTranslationEquation';
import taskTemplateReducer from './taskTemplates';
import checklistTemplateReducer from './checklistTemplates';
import checklistReducer from './checklist';
import tasksReducer from './tasks';
import signalTranslationReducer from './signalTranslation';
import eventCodeReducer from './eventCode';
import modelReducer from './model';
import componentPartsReducer from './componentParts';
import modelComponentTypeReducer from './modelComponentTypes';
import approvedComponentReducer from './approvedComponents';
import unitConfigurationReducer from './unitConfiguration';
import telemetryLinksReducer from './telemetryLinks';
import unitTagoutHistoryReducer from './unitTagoutHistory';
import forgotPasswordReducer from './forgotPassword';
import commandSchedulerReducer from './commandScheduler';
import unitServicesReducer from './unitServices';
import dailySummaryReducer from './dailySummary';
import unitStatisticsReducer from './unitStatistics';
import telemetryPartsReducer from './telemetryParts';
import notificationsReducer from './notifications';
import faqCategoryReducer from './faqCategories';
import faQuestionReducer from './faQuestions';
import organisationRegionReducer from './organisationRegions';
import modelFirmwareVersionReducer from './modelFirmwareVersion';
import releaseNotesReducer from './releaseNotes';
import unitReducer from './unit';
import sequenceVersionReducer from './sequenceVersion';
import staticDataReducer from './staticData';
import errorReducer from './errorReducer';
import unitOverview from './unitOverview';
import modelCategoryReducer from './modelCategory';
import userOrganisationModelCategoryReducer from './userOrganisationModelCategory';

const createRootReducer = (routerReducer) => {
  // Combine all the reducers
  const reducers = {
    error:errorReducer,
    charts: chartsReducer,
    devices: devicesReducer,
    events: eventsReducer,
    user: userReducer,
    ui: uiReducer,
    sensors: sensorsReducer,
    locale: localeReducer,
    timezone: timezoneReducer,
    profile: profilesReducer,
    sidebarOpen: sidebarReducer,
    appWidgets: appWidgetReducer,
    userProfileWidgets: userProfileWidgetsReducer,
    userProfileUnits: userProfileUnitsReducer,
    userManager: userManagerReducer,
    unitManager: unitManagerReducer,
    modelManager: modelReducer,
    modelCategoryManager: modelCategoryReducer,
    modelVariantManager: modelVariantReducer,
    modelFirmwareVersionManager: modelFirmwareVersionReducer,
    organisationManager: organisationManagerReducer,
    setpoints: setpointsReducer,
    modelComponentPositionManager: modelComponentPositionsReducer,
    alarms: alarmsReducer,
    eventAction: eventActionReducer,
    eventActionStatus: eventActionStatusReducer,
    signalTranslationEquation: signalTranslationEquationReducer,
    taskTemplate: taskTemplateReducer,
    checklistTemplate: checklistTemplateReducer,
    tasks: tasksReducer,
    signalTranslation: signalTranslationReducer,
    checklist: checklistReducer,
    event: checklistReducer,
    eventCode: eventCodeReducer,
    componentParts: componentPartsReducer,
    modelComponentType: modelComponentTypeReducer,
    approvedComponent: approvedComponentReducer,
    unitConfiguration: unitConfigurationReducer,
    telemetryLinks: telemetryLinksReducer,
    unitTagoutHistory: unitTagoutHistoryReducer,
    forgotPassword: forgotPasswordReducer,
    commandScheduler: commandSchedulerReducer,
    unitService: unitServicesReducer,
    dailySummary: dailySummaryReducer,
    unitStatistics: unitStatisticsReducer,
    telemetryParts: telemetryPartsReducer,
    notifications: notificationsReducer,
    faqCategory: faqCategoryReducer,
    faQuestion: faQuestionReducer,
    organisationRegion: organisationRegionReducer,
    releaseNote: releaseNotesReducer,
    unit: unitReducer,
    sequenceVersionManager: sequenceVersionReducer,
    staticDataManager: staticDataReducer,
    unitOverview:unitOverview,
    userOrganisationModelCategory: userOrganisationModelCategoryReducer,
    // This is the key change - router becomes a normal reducer
    router: routerReducer
  };

  const appReducer = combineReducers(reducers);

  return (state, action) => {
    if (action.type === LOGOUT) {
      state = undefined;
    }
    return appReducer(state, action);
  };
};

export default createRootReducer;